



































































































import Vue from 'vue'
import CategoryPostBreadcrumbs from '@/components/common/CategoryPostBreadcrumbs.vue'
import VideoPlayer from '@/components/product/VideoPlayer.vue'
import PostQueue from '@/components/product/PostQueue.vue'
import InstructorCard from '@/components/product/InstructorCard.vue'
import PostMaterialsCard from '@/components/product/PostMaterialsCard.vue'
import GoToNextPost from '@/components/product/GoToNextPost.vue'
import CommentList from '@/components/comments/CommentList.vue'
import { PostService } from '@/services'

export default Vue.extend({
  components: {
    CategoryPostBreadcrumbs,
    VideoPlayer,
    PostQueue,
    PostMaterialsCard,
    InstructorCard,
    GoToNextPost,
    CommentList
  },
  props: {
    product: {
      type: Object
    },
    instructor: {
      type: Object
    },
    activePost: {
      type: Object
    },
    category: {
      type: Object
    },
    videoOptions: {
      type: Object
    },
    nextPost: {
      type: Object
    },
    playlist: {
      type: Array
    },
    disableActions: {
      type: Object
    },
    nextCategoryId: String,
    markCompletedBtnCss: String,
    postCompletionButtonText: String,
    lessonButton: Object,
    isAdmin: Boolean,
    nextLesson: String,
    fetchingPost: Boolean,
    fetchingPostCompletionStatus: Boolean,
    disablePostCompletionButton: Boolean,
    completedPostIds: {
      type: Set,
      default: new Set()
    }
  },
  data() {
    return {
      post: {}
    }
  },
  computed: {
    productId(): string {
      return this.$route.params.id
    },
    categoryId(): string {
      return this.$route.params.category_id
    },
    postId(): string {
      return this.$route.params.post_id
    }
  },
  async mounted() {
    try {
      this.post = await PostService.findById(this.postId)
    } catch (error) {
      console.log("Something went wrong")
    }
  },
  methods: {
    togglePostCompletion() {
      this.$emit('togglePostCompletion')
    }
  }
})
